import React from 'react'

export const ComingSoonWidget = () => {
    return <p>Coming Soon</p>
}